import { ChakraV3 } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import React from 'react';
import { useController } from 'react-hook-form';

export interface SliderOption {
  value: string;
  label: string;
}

interface Props extends ChakraV3.SliderRootProps {
  name: string;
  options: SliderOption[];
}

export const HookedEpisodicSeveritySlider = (props: Props) => {
  const { name, defaultValue, ...rest } = props;

  const {
    field: { ref, ...inputProps },
  } = useController({ name });

  const selectedValue = props.options[inputProps.value - 1];

  const level = `Level ${inputProps.value}`;

  const onChange = React.useCallback(
    (value: number[]) => {
      inputProps.onChange(value[0]);
    },
    [inputProps.onChange],
  );

  React.useEffect(() => {
    if (P.isNil(inputProps.value) && !P.isNil(defaultValue)) {
      inputProps.onChange(defaultValue[0]);
    }
  }, [defaultValue, inputProps.onChange, inputProps.value]);

  return (
    <ChakraV3.Stack w='full'>
      <ChakraV3.Slider.Root
        size='sm'
        colorPalette='brand'
        value={[inputProps.value]}
        onValueChange={(value) => onChange(value.value)}
        onBlur={inputProps.onBlur}
        {...rest}
      >
        <ChakraV3.Slider.Control>
          <ChakraV3.Slider.Track>
            <ChakraV3.Slider.Range />
          </ChakraV3.Slider.Track>
          <ChakraV3.Slider.Thumb index={0} shadow='popover' />
        </ChakraV3.Slider.Control>
      </ChakraV3.Slider.Root>
      <ChakraV3.Text fontSize='sm'>
        <strong>{level}</strong>: {selectedValue?.label}
      </ChakraV3.Text>
    </ChakraV3.Stack>
  );
};
